// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2f6e73a1","977":"5900c500"}[chunkId] + ".chunk.js";
};